<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="State Select"
    seFeDataSubtitle="A state selector"
    size="750">
  </se-fe-header>
  <div seFePageContent>
    <se-fe-card>
      <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
      <se-fe-card-content>
        <p>Use this component for state or province select inputs</p>
        <p>Shows both all US states and Canadian provinces by default.</p>
        <p>If a country (US or CA) is passed in, will only show options for that country.</p>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card>
      <se-fe-card-header seFeDataTitle="StateSelectComponent"></se-fe-card-header>
      <se-fe-card-content>
        <se-fe-docs-table
          [seFeDataHeaders]="headers"
          [seFeDataRows]="stateSelectComponent">
        </se-fe-docs-table>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="State or Province Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-state-province-select-example></se-po-state-province-select-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="State Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-state-select-example></se-po-state-select-example>
      </se-fe-card-content>
    </se-fe-card>

    <se-fe-card class="form-example">
      <se-fe-card-header seFeDataTitle="Province Example Code"></se-fe-card-header>
      <se-fe-card-content>
        <se-po-province-select-example></se-po-province-select-example>
      </se-fe-card-content>
    </se-fe-card>
  </div>
</se-fe-page>
